import { createFileRoute } from "@tanstack/react-router";
import { Library as LibraryIcon } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { Library } from "@/features/research/modules/library/library";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/library/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.research_library_title() }),
});

function RouteComponent() {
  return (
    <PageShell icon={LibraryIcon} title={m.research_library_title()} description={m.research_library_description()}>
      <Library />
    </PageShell>
  );
}
